export default from './no-posts';



// WEBPACK FOOTER //
// ./app/components/no-posts/index.js